import { CFade } from '@coreui/react';
import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { useAuth } from '../auth/useAuth';
import { AuthLayout } from '../components/layout/AuthLayout/AuthLayout';
import { Layout } from '../components/layout/Layout/Layout';
import { NotFound } from '../routes/notFound/NotFound';
import { getRoutes, routeConfig } from './routeConfig';

const LoggedOut = React.lazy(() => import('../routes/loggedOut/LoggedOut'));

export const RouteSwitcher:React.FC = (): any => {
  const { token } = useAuth();
  const { pathname } = useLocation();

  if (pathname === '/logged-out') {
    return (
      <AuthLayout>
        <Route
          path="/logged-out"
          exact={true}
          render={(props: any) => (
            <CFade>
              <LoggedOut {...props}/>
            </CFade>
          )}
        />
        <Redirect to={'/logged-out'} />
      </AuthLayout>
    );
  }

  if (token) {
    return (
      <Layout>
        <React.Suspense fallback={null}>
          <Switch>
            {getRoutes()
              .map((route, idx) => (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  render={(props: any) => (
                    <CFade>
                      <route.component {...props} />
                    </CFade>
                  )}
                />
              ))}
            <Redirect to={{ pathname: routeConfig.dashboard.path, search: '' }} />
            <NotFound />
          </Switch>
        </React.Suspense>
      </Layout>
    );
  }

  return null;
};
